import { render, staticRenderFns } from "./Actor.vue?vue&type=template&id=0075a73e&scoped=true&"
import script from "./Actor.vue?vue&type=script&lang=js&"
export * from "./Actor.vue?vue&type=script&lang=js&"
import style0 from "./Actor.vue?vue&type=style&index=0&id=0075a73e&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075a73e",
  null
  
)

export default component.exports